import clsx from 'clsx';
import React from 'react';

interface TagProps {
  className?: string;
  name: string;
}

const Tag = ({ name, className }: TagProps) => {
  return (
    <span
      className={clsx(
        'whitespace-nowrap rounded-28 bg-secondary-pink px-24 py-6 font-sans text-button-sm font-medium text-primary-red',
        className
      )}
    >
      {name}
    </span>
  );
};

export default Tag;
